import React, { useMemo } from 'react';
import { Segment } from 'tea-component';
import { IconFourList } from '@intelligence/components/CardSlotV2';
import CountryTable from './Table';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { getCountriesCardTitleI18nKey } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_config/countriesCardTitle';

const CountriesCard = (props: any) => {
  const {
    loading,
    tableData = [],
    unPublishedAppIdList = [],
    segmentOptions,
    tableHeaderOptions,
    changeSegement,
    lineData,
    cardStatus,
    fixedTableData,
    entityType,
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    baseReleaseTime,
    earliestPeriod,
    earliestDay,
    setChartType,
    chartType,
    pageSortAttr,
    onTableSortChage,
    countriesType: regionSegVal,
    metricSegVal,
    changeSegementRight,
    regionsCountries,
    retentionMetricSource = 'appannie',

  } = props;

  // console.log('CountriesCard234',props);

  const { formatMessage } = useIntlExtend(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};
  // const [regionSegVal, setRegionSegVal] = useState('market');
  // const [metricSegVal, setMetricSegVal] = useState(segmentOptions?.[0]?.value);

  const countriesSharTitle = useMemo(() => {
    const titleI18nKey = getCountriesCardTitleI18nKey({
      dimension: regionSegVal,
      metric: metricSegVal,
      chartType,
    });

    return formatMessage({ id: titleI18nKey });
  }, [regionSegVal, metricSegVal, chartType, formatMessage]);

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={countriesSharTitle}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-countries-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={countriesSharTitle}
        rightText={earliestDay ? `${formatMessage({ id: `dbi_detail_earliest_date` })}: ${earliestDay}` : ''}
        rightTip={earliestDay ? formatMessage({ id: `dbi_detail_earlistdate_info` }) : ''}
        disableChartType={['bar', 'pie']}
        iconList={IconFourList}
        activeTab={chartType}
        getChange={(value: any) => {
          setChartType(value);
        }}
      >
        <div className="retention-segment">
          <Segment
            className="segment-right"
            value={regionSegVal}
            onChange={(value) => {
              // setRegionSegVal(value);
              changeSegement?.(value);
            }}
            options={[
              { text: formatMessage({ id: 'dbi_game_detail_countries' }), value: 'market' },
              { text: formatMessage({ id: 'dbi_game_detail_region' }), value: 'region' },
            ]}
          />
          <Segment
            value={metricSegVal}
            onChange={(value) => {
              changeSegementRight?.(value);
              // setMetricSegVal(value)
            }}
            // onChange={(value) => setMetricSegVal(value)}
            options={segmentOptions}
          />
        </div>
        <div className="trends-card-line">
          <Visualis
            lineData={lineData}
            metricSegVal={metricSegVal}
            dateType={dateType}
            regionSegVal={regionSegVal}
            baseReleaseTime={baseReleaseTime}
            earliestPeriod={earliestPeriod}
            chartType={chartType}
            isStackLine={chartType === 'stackedLine'}
            regionsCountries={regionsCountries}
            retentionMetricSource={retentionMetricSource}
          />
        </div>
        <CountryTable
          loading={loading}
          chartSegment={metricSegVal} /**用于表格展示排序 */
          tableData={tableData}
          unPublishedAppIdList={unPublishedAppIdList}
          tableHeaderOptions={tableHeaderOptions}
          fixedTableData={fixedTableData}
          regionSegVal={regionSegVal}
          entityType={entityType}
          gameName={gameName}
          gameCover={gameCover}
          dateType={dateType}
          startDate={startDate}
          endDate={endDate}
          pageSortAttr={pageSortAttr}
          onTableSortChage={onTableSortChage}
          retentionMetricSource={retentionMetricSource}
        />
      </CardSlotV2>
    </div>
  );
};

export default CountriesCard;
